<template>
	<div class="row d-flex align-items-start">
		<FormulateInput
			v-model="context.model"
			v-bind="context.attributes"
			type="text"
			:class="{ 'col-lg-6': codeSend }"
			:label="context.attributes['label-text']"
			class="col-12 mb-0"
			validation="bail|required|email"
			:validation-messages="{
				'required': 'укажите значение',
				'email': 'введите корректный e-mail',
			}"
			@input="debounceVerify"
		>
			<template #help>
				<div v-if="exist" class="help mt-2 small">
					<span v-if="codeSend" class="success">
						Письмо отправлено
					</span>
					<span v-else>
						У вас уже есть аккаунт.
						<a :class="{ disabled: loading }" @click="sendCode">
							Войти по коду
						</a>
					</span>
				</div>
				<div v-if="error" class="error small">
					{{ error }}
				</div>
			</template>
		</FormulateInput>
		<FormulateInput
			v-if="codeSend"
			v-model="code"
			class="col-12 col-lg-6"
			type="text"
			label="Код подтверждения из письма"
			placeholder="Введите значение"
			@input="codeHandler"
		>
			<template #help>
				<div v-if="loginError" class="error">
					{{ loginError }}
				</div>
			</template>
		</FormulateInput>
	</div>
</template>

<script>
import debounce from 'lodash/debounce';

const TIMEOUT = 1000;
const CODE_LENGTH = 6;

export default {
	components: {
	},
	inject: ['setExist'],
	props: {
		context: {
			type: Object,
			required: true,
		},
	},
	data() {
		return {
			exist: false,
			codeSend: false,
			loading: false,
			code: '',
			error: '',
			loginError: '',
		};
	},
	methods: {
		debounceVerify: debounce(function () {
			if (this.$auth.user) return;

			if (!this.context.model) {
				this.exist = false;
				this.codeSend = false;
			}
			this.verifyOnExist();
		}, TIMEOUT),
		async verifyOnExist() {
			try {
				if (!this.context.model) return;

				const { data: { email_exists } } = await this.$api.checkEmailExist(this.context.model);
				this.exist = email_exists;

				if (this.setExist) {
					this.setExist(email_exists, this.context.model);
				}
			} catch (e) {
				console.error(e);
				this.exist = false;
				this.codeSend = false;
				this.setExist(false, this.context.model);
			}
		},
		async sendCode() {
			try {
				this.loading = true;
				const email = this.context.model;

				await this.$api.codeGenerate({ email });
				this.codeSend = true;
			} catch (error) {
				try {
					const {
						message,
					} = this.$api.getValidationFromError(error);
					this.error = message;
				} catch {
					console.error(error);
					this.error = 'Что-то пошло не так';
				}
			} finally {
				this.loading = false;
			}
		},
		async codeHandler() {
			if (this.code.length === CODE_LENGTH) {
				await this.loginWithCode();
			}
		},
		async loginWithCode() {
			try {
				await this.$auth.loginWith('code', {
					data: {
						code: this.code,
						email: this.context.model,
					},
				}).then((res) => {
					if (res.data?.data) {
						window.dataLayer = window.dataLayer || [];
						window.dataLayer.push({
							event: 'login',
							user_id: res.data.data.id,
							counterparty_type: res.data.data.counterparty_type ? 'Корпоративный клиент' : 'Физическое лицо',
						});
					}
				});

				this.exist = false;
				this.codeSend = false;
			} catch (error) {
				try {
					const {
						message,
					} = this.$api.getValidationFromError(error);
					this.loginError = message;
				} catch {
					console.error(error);
					this.loginError = 'Что-то пошло не так';
				}
			}
		},
	},
};
</script>

<style scoped lang="scss">
@import "assets/styles/sk_variables";
// For use bootstrap vars and mixins inside
@import "assets/styles/bootstrap/scss/functions";
@import "assets/styles/bootstrap/scss/variables";
@import "assets/styles/bootstrap/scss/mixins";

.help {
	a {
		color: $primary;
		cursor: pointer;
		text-decoration: underline;

		&.disabled {
			pointer-events: none;
			color: $gray-500;
		}
	}

	.success {
		color: green;
	}
}
</style>
